// extracted by mini-css-extract-plugin
export default {"preview":"avatar-preview__preview__Exp7B"};